<template>
  <div id="app">
    <fidelior-navigation />
    <div v-if="state.alerts.messages">
      <b-alert
        v-for="alert in state.alerts.messages"
        :key="alert.name"
        :variant="alert.success"
        show
        class="alert-dismissible"
      >
        <button
          type="button"
          class="close"
          aria-label="Close"
          data-dismiss="alert"
          v-on:click="state.alerts.remove(alert)"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        {{alert.message}}
      </b-alert>
    </div>
    <div class="container-fluid">
      <div class="row row-offcanvas row-offcanvas-left">
        <div id="application-content" class="main col-sm-12 col-md-12 p-0">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/bootstrap.scss";
import "@/assets/site.css";
import state from "@/state.js";

import Navigation from "./components/fidelior-navigation.vue";

export default {
  name: "app",
  data() {
    return {
      state: state
    };
  },
  components: {
    "fidelior-navigation": Navigation
  }
};
</script>
